
function ImageGalleryBlock() {
    const AutomaticScrollDelay = 3000;
    for (let imageGalleryBlock of document.querySelectorAll('.image-gallery-block')) {
        let slides = imageGalleryBlock.querySelector('.slides');
        let buttons = imageGalleryBlock.querySelector('.slide-navigation').querySelectorAll('button');
        let lightbox = imageGalleryBlock.querySelector('.lightbox');
        let overlay = lightbox.querySelector('.overlay');
        let container = lightbox.querySelector('.content');
        let activeButton = buttons[0];
        let activeIndex = 0;
        let lightboxSlide = null;
        let players = [];
        function ScrollAutomatically() {
            let activeSlide = slides.children[activeIndex + 1];
            slides.scrollTo({ 'left': activeSlide.offsetLeft, 'behavior': 'smooth' });
            scrollAutomatically = window.setTimeout(ScrollAutomatically, AutomaticScrollDelay);
        }
        let scrollAutomatically = window.setTimeout(ScrollAutomatically, AutomaticScrollDelay);
        for (let index = 0; index < buttons.length; index += 1) {
            let slide = slides.children[index];
            let button = buttons[index];
            button.addEventListener('click', function() {
                slides.scrollTo({ 'left': slide.offsetLeft - slides.offsetLeft, 'behavior': 'smooth' });
            });
        }
        slides.addEventListener('scroll', function() {
            if (scrollAutomatically !== null) {
                window.clearTimeout(scrollAutomatically);
                scrollAutomatically = window.setTimeout(ScrollAutomatically, AutomaticScrollDelay);
            }
            activeButton.classList.remove('active');
            activeButton.classList.add('inactive');
            activeIndex = Math.round(slides.scrollLeft/slides.children[0].clientWidth) % buttons.length;
            activeButton = buttons[activeIndex];
            activeButton.classList.remove('inactive');
            activeButton.classList.add('active');
            if (slides.scrollWidth <= slides.scrollLeft + slides.clientWidth + 1) {
                slides.scrollTo({ 'left': 0, 'behavior': 'instant' });
            }
        });
        let previews = lightbox.querySelector('.content');
        let active = null;
        for (let index = 0; index < slides.children.length; index += 1) {
            let slide = slides.children[index];
            let thumbnail = slide.querySelector('.thumbnail');
            let preview = previews.children[index % previews.children.length];
            let player;
            if (preview.classList.contains('video')) {
                thumbnail.addEventListener('mouseover', function() {
                    if (preview.getAttribute("loading") === "lazy") {
                        preview.setAttribute("loading", "eager");
                    }
                });
                player = new YT.Player(preview, {
                    events: {
                        onReady: function() {
                            console.log("readyPlayer", player);
                        }
                    }
                });
            }
            else {
                player = null;
            }
            players[index] = player;
            thumbnail.addEventListener('click', function() {
                window.clearTimeout(scrollAutomatically);
                scrollAutomatically = null;
                active = index % previews.children.length;
                lightbox.removeAttribute('hidden');
                preview.removeAttribute('hidden');
                lightbox.animate([
                    {
                        opacity: "0",
                    },
                    {
                        opacity: "1",
                    },
                ], { duration: 500, easing: 'ease-in' });
                container.animate([
                    {
                        width: `${container.offsetWidth}px`,
                        height: `${container.offsetHeight}px`,
                    },
                ], { duration: 500, easing: 'step-start' });
                let thumbnailBoundingRectangle = thumbnail.getBoundingClientRect();
                let previewBoundingRectangle = preview.getBoundingClientRect();
                preview.animate([
                    {
                        position: "relative",
                        width: `${thumbnail.offsetWidth}px`,
                        height: `${thumbnail.offsetHeight}px`,
                        top: `${thumbnailBoundingRectangle.top - previewBoundingRectangle.top}px`,
                        left: `${thumbnailBoundingRectangle.left - previewBoundingRectangle.left}px`,
                    },
                    {
                        position: "relative",
                        width: `${preview.offsetWidth}px`,
                        height: `${preview.offsetHeight}px`,
                        top: "0",
                        left: "0",
                    },
                ], { duration: 500, easing: 'ease' });
                if (active === 0) {
                    previous.setAttribute("hidden", "hidden");
                }
                else {
                    previous.removeAttribute("hidden");
                }
                if (active === previews.children.length - 1) {
                    next.setAttribute("hidden", "hidden");
                }
                else {
                    next.removeAttribute("hidden");
                }
                if (player !== null) {
                    if (typeof player.playVideo === 'function') {
                        player.playVideo();
                    }
                    else {
                        player.addEventListener('onReady', function(event) {
                            player.playVideo();
                        });
                    }
                }
            });
        }
        let close = lightbox.querySelector('.close');
        close.addEventListener('click', function() {
            scrollAutomatically = window.setTimeout(ScrollAutomatically, AutomaticScrollDelay);
            let animation = lightbox.animate([
                {
                    opacity: "1",
                },
                {
                    opacity: "0",
                },
            ], { duration: 500, easing: 'ease-in' });
            animation.addEventListener("finish", function() {
                lightbox.setAttribute("hidden", "hidden");
                preview.setAttribute("hidden", "hidden");
            });
            let slide = slides.children[active];
            let thumbnail = slide.querySelector('.thumbnail');
            let preview = previews.children[active];
            container.animate([
                {
                    width: `${container.offsetWidth}px`,
                    height: `${container.offsetHeight}px`,
                },
            ], { duration: 500, easing: 'step-start' });
            let thumbnailBoundingRectangle = thumbnail.getBoundingClientRect();
            let previewBoundingRectangle = preview.getBoundingClientRect();
            preview.animate([
                {
                    position: "relative",
                    width: `${preview.offsetWidth}px`,
                    height: `${preview.offsetHeight}px`,
                    top: "0",
                    left: "0",
                },
                {
                    position: "relative",
                    width: `${thumbnail.offsetWidth}px`,
                    height: `${thumbnail.offsetHeight}px`,
                    top: `${thumbnailBoundingRectangle.top - previewBoundingRectangle.top}px`,
                    left: `${thumbnailBoundingRectangle.left - previewBoundingRectangle.left}px`,
                },
            ], { duration: 500, easing: 'ease' });
            let player = players[active];
            if (player !== null) {
                player.pauseVideo();
            }
        });
        let previous = lightbox.querySelector('.previous');
        let next = lightbox.querySelector('.next');
        previous.addEventListener('click', function() {
            let currentPreview = previews.children[active];
            let currentPlayer = players[active];
            let animation = currentPreview.animate([
                {
                    position: "absolute",
                    left: `${currentPreview.offsetLeft}px`,
                    top: "50%",
                    width: `${currentPreview.offsetWidth}px`,
                    height: `${currentPreview.offsetHeight}px`,
                    transform: "translateY(-50%)",
                    opacity: "1",
                },
                {
                    position: "absolute",
                    left: `calc(${currentPreview.offsetLeft}px + 50%)`,
                    top: "50%",
                    width: `${currentPreview.offsetWidth}px`,
                    height: `${currentPreview.offsetHeight}px`,
                    transform: "translateY(-50%)",
                    opacity: "0",
                },
            ], { duration: 300, easing: "ease-out" });
            animation.addEventListener("finish", function() {
                currentPreview.setAttribute('hidden', 'hidden');
            });
            if (currentPlayer !== null) {
                if (typeof currentPlayer.pauseVideo === "function") {
                    currentPlayer.pauseVideo();
                }
                else {
                    currentPlayer.addEventListener("onReady", function() {
                        currentPlayer.pauseVideo();
                    });
                }
            }
            active = active - 1;
            let slidesOnScreen = Array.prototype.findIndex.call(slides.children, function(slide) {
                return slides.offsetWidth <= slide.offsetLeft;
            });
            activeIndex = active;
            if (slidesOnScreen === 3 && activeIndex !== 0) {
                activeIndex -= 1;
            }
            let activeSlide = slides.children[activeIndex];
            slides.scrollTo({ 'left': activeSlide.offsetLeft, 'behavior': 'smooth' });
            let previousPreview = previews.children[active];
            let previousPlayer = players[active];
            if (previousPlayer !== null) {
                if (typeof previousPlayer.playVideo === "function") {
                    previousPlayer.playVideo();
                }
                else {
                    previousPlayer.addEventListener("onReady", function() {
                        previousPlayer.playVideo();
                    });
                }
            }
            previousPreview.removeAttribute("hidden");
            previousPreview.animate([
                {
                    position: "relative",
                    left: "-50%",
                    opacity: "0",
                },
                {
                    position: "relative",
                    left: "0",
                    opacity: "1",
                },
            ], { duration: 300, easing: "ease-out" });
            if (active === 0) {
                previous.setAttribute("hidden", "hidden");
            }
            next.removeAttribute("hidden");
        });
        next.addEventListener('click', function() {
            let currentPreview = previews.children[active];
            let currentPlayer = players[active];
            let animation = currentPreview.animate([
                {
                    position: "absolute",
                    left: `${currentPreview.offsetLeft}px`,
                    top: "50%",
                    width: `${currentPreview.offsetWidth}px`,
                    height: `${currentPreview.offsetHeight}px`,
                    transform: "translateY(-50%)",
                    opacity: "1",
                },
                {
                    position: "absolute",
                    left: `calc(${currentPreview.offsetLeft}px - 50%)`,
                    width: `${currentPreview.offsetWidth}px`,
                    height: `${currentPreview.offsetHeight}px`,
                    top: "50%",
                    transform: "translateY(-50%)",
                    opacity: "0",
                },
            ], { duration: 300, easing: "ease-out" });
            animation.addEventListener("finish", function() {
                currentPreview.setAttribute('hidden', 'hidden');
            });
            if (currentPlayer !== null) {
                if (typeof currentPlayer.pauseVideo === "function") {
                    currentPlayer.pauseVideo();
                }
                else {
                    currentPlayer.addEventListener("onReady", function() {
                        currentPlayer.pauseVideo();
                    });
                }
            }
            active = active + 1;
            let slidesOnScreen = Array.prototype.findIndex.call(slides.children, function(slide) {
                return slides.offsetWidth <= slide.offsetLeft;
            });
            activeIndex = active;
            if (slidesOnScreen === 3 && activeIndex !== 0) {
                activeIndex -= 1;
            }
            let activeSlide = slides.children[activeIndex];
            slides.scrollTo({ 'left': activeSlide.offsetLeft, 'behavior': 'smooth' });
            let nextPreview = previews.children[active];
            nextPreview.removeAttribute("hidden");
            nextPreview.animate([
                {
                    position: "relative",
                    left: "50%",
                    opacity: "0",
                },
                {
                    position: "relative",
                    left: "0",
                    opacity: "1",
                },
            ], { duration: 300, easing: "ease-out" });
            let nextPlayer = players[active];
            if (nextPlayer !== null) {
                if (typeof nextPlayer.playVideo === "function") {
                    nextPlayer.playVideo();
                }
                else {
                    nextPlayer.addEventListener("onReady", function() {
                        nextPlayer.playVideo();
                    });
                }
            }
            previous.removeAttribute("hidden");
            if (active === previews.children.length - 1) {
                next.setAttribute("hidden", "hidden");
            }
        });
        previous.addEventListener("mouseover", function() {
            let previousPreview = previews.children[active - 1];
            if (previousPreview.classList.contains("video") && previousPreview.getAttribute("loading") === "lazy") {
                previousPreview.setAttribute("loading", "eager");
            }
        });
        next.addEventListener("mouseover", function() {
            let nextPreview = previews.children[active + 1];
            if (nextPreview.classList.contains("video") && nextPreview.getAttribute("loading") === "lazy") {
                nextPreview.setAttribute("loading", "eager");
            }
        });
        /*for (let slide of slides.children) {
            slide.addEventListener('click', function() {
                lightbox.removeAttribute('hidden');
                window.clearTimeout(scrollAutomatically);
                let fromPosition = slide.getBoundingClientRect();
                slide.classList.add('in-lightbox');
                document.documentElement.classList.add('viewing-lightbox');
                lightboxSlide = slide;
                let toPosition = slide.getBoundingClientRect();
                slide.animate([
                    { left: `${fromPosition.left}px`, top: `${fromPosition.top}px`, width: `${fromPosition.width}px`, height: `${fromPosition.height}px`, transform: 'translate(0%, 0%)' },
                    { left: `${toPosition.left}px`, top: `${toPosition.top}px`, width: `${toPosition.width}px`, height: `${toPosition.height}px`, transform: 'translate(0%, 0%)' },
                ], { duration: 500, easing: 'ease' });
            });
        }
        overlay.addEventListener('click', function() {
            let slide = lightboxSlide;
            lightboxSlide = null;
            lightbox.setAttribute('hidden', 'hidden');
            let fromPosition = slide.getBoundingClientRect();
            slide.classList.remove('in-lightbox');
            let toPosition = slide.getBoundingClientRect();
            slide.classList.add('in-lightbox');
            let animation = slide.animate([
                { left: `${fromPosition.left}px`, top: `${fromPosition.top}px`, width: `${fromPosition.width}px`, height: `${fromPosition.height}px`, transform: 'translate(0%, 0%)' },
                { left: `${toPosition.left}px`, top: `${toPosition.top}px`, width: `${toPosition.width}px`, height: `${toPosition.height}px`, transform: 'translate(0%, 0%)' },
            ], { duration: 500, easing: 'ease' });
            animation.addEventListener('finish', function() {
                document.documentElement.classList.remove('viewing-lightbox');
                slide.classList.remove('in-lightbox');
            })
        });
        let previous = lightbox.querySelector('.previous');
        let next = lightbox.querySelector('.next');
        previous.addEventListener('click', function(event) {
            lightboxSlide.classList.remove('in-lightbox');
            lightboxSlide = slides.children[(Array.prototype.indexOf.call(slides.children, lightboxSlide) - 1) % buttons.length];
            lightboxSlide.classList.add('in-lightbox');
        });
        next.addEventListener('click', function(event) {
            lightboxSlide.classList.remove('in-lightbox');
            lightboxSlide = slides.children[(Array.prototype.indexOf.call(slides.children, lightboxSlide) + 1) % buttons.length];
            lightboxSlide.classList.add('in-lightbox');
        });
        */
    }
}

if (typeof YT !== 'undefined' && YT.loaded) {
    ImageGalleryBlock();
}
else if (window.hasOwnProperty('onYouTubeIframeAPIReady')) {
    let onYouTubeIframeAPIReady = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function() {
        onYouTubeIframeAPIReady();
        ImageGalleryBlock();
    }
}
else {
    window.onYouTubeIframeAPIReady = ImageGalleryBlock;
}
